

export const index = 5;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/neurologie-und-geriatrie/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/5.B13qzgAh.js","_app/immutable/chunks/DowcGjab.js","_app/immutable/chunks/BzCi4Of2.js","_app/immutable/chunks/DuUomSZU.js"];
export const stylesheets = [];
export const fonts = [];
